import { $axios } from '~/utils/api'

const getChildren = (): Promise<any> => $axios.$get('/children')

export { getChildren }
